import React, { Fragment, useCallback } from 'react';
import { CollapsableLocationProps } from './types';
import { CheckBoxListDropdownMain, CheckBoxWrapper } from './styled';
import { Checkbox } from '../../../../ui/Checkbox';

export const CollapsableLocation = ({
  location,
  townships,
  isFullName,
  chosenLocationIds,
  onCheckGroupHandler,
  onChangeCheckboxHandler
}: CollapsableLocationProps) => {
  const { id } = location;
  const collapsed = false;
  const nestedTownships = (townships ?? []).filter(
    township => township?.parent?.id === id
  );

  const handleCheckGroup = useCallback(
    e => {
      e.preventDefault();
      onCheckGroupHandler(
        [...nestedTownships, location],
        !chosenLocationIds?.includes(id)
      );
    },
    [chosenLocationIds]
  );

  const hasMultipleOptions = !!nestedTownships?.length;
  const isDistrict = townships !== null;

  return (
    <Fragment>
      <CheckBoxListDropdownMain
        aria-checked={!collapsed}
        data-cy="new-search-checkbox-list--dropdown__main"
        hasBottomBottom={isDistrict && !hasMultipleOptions}
      >
        <Checkbox
          stat="new-search-check-locations"
          cypress="location"
          name="search-locations"
          currentValues={chosenLocationIds || []}
          onChangeHandler={
            hasMultipleOptions ? handleCheckGroup : onChangeCheckboxHandler
          }
          id={location.id}
          label={isFullName ? location.fullName : location.name}
          markAlign="left"
          isGroupCheckbox={!!townships}
        />
      </CheckBoxListDropdownMain>
      {hasMultipleOptions && (
        <>
          {nestedTownships.map((township, index) => (
            <CheckBoxWrapper
              key={township.id}
              isLastChild={index === nestedTownships.length - 1}
            >
              <Checkbox
                key={township.id}
                stat="new-search-check-locations"
                cypress={`location_${township.id}`}
                name="search-locations"
                currentValues={chosenLocationIds || []}
                onChangeHandler={onChangeCheckboxHandler}
                id={township.id}
                label={township.name}
                markAlign="left"
              />
            </CheckBoxWrapper>
          ))}
        </>
      )}
    </Fragment>
  );
};
